import I18n from 'i18n-js';
import en from './English.js';

// const locale = navigator.language;

// if (locale) {
//   I18n.locale = locale;
// }

I18n.fallbacks = true;
I18n.defaultLocale = 'en';

I18n.translations = {
  en
};

export default I18n;
